// File for logic corresponding to the closings page

import ClosingsPage from './closings-page';

const closingsPageConfig = {
  name: 'closingsPage',
  class: ClosingsPage,
  querySelector: {
    closingsNav: '.closings-nav',
    closingsNavItems: '.closings-nav__items',
    toggle: '.closings-nav__toggle',
    toggleIconDefault: '.closings-nav__toggle-icon-default',
    toggleIconClose: '.closings-nav__toggle-icon-close',
  },
  querySelectorAll: {
    splittedChars: '[data-split-chars]',
  },
  options: {
    menuActiveClass: 'closings-nav--active',
  },
};

export default closingsPageConfig;
